import React from 'react'

import { Col } from '../structure/Grid'
import { SmallText } from '../presentation/Text'
import Icon from '../shapes/Icon'
import Panel from '../structure/Panel'
import Picker from './picker/Picker'
import Separator from '../helpers/Separator'

const Card = ({ option, isSelected, onClick, ...props }) => {
  const color = isSelected ? 'primary' : 'light5'

  return (
    <Col width="33.33%">
      <Panel
        height="100%"
        borderColor={color}
        onClick={onClick}
        align="center"
        justify="center"
        paddingV={0.8}
        borderStyle={!isSelected && 'dashed'}
      >
        <Icon name={option?.icon} size={1.2} color={color} />
        <Separator weight={2} />
        <SmallText align="center" size="xsmall" bold={isSelected}>
          {option?.name || option}
        </SmallText>
      </Panel>
    </Col>
  )
}

const CardPicker = ({ value, onChange, options, ...props }) => {
  return (
    <Picker
      options={options}
      value={value}
      onChange={onChange}
      Selector={Card}
      wrap
      direction="row"
      paddingGutter={0.2}
      {...props}
    />
  )
}

export default CardPicker
